module.exports = __webpack_public_path__ + "media/application/images/icons/left-arrow-8bdf4c3e1a493e23bd1b815d7cbbfee4.svg";